import { trackAction, TRACKING } from '@xing-com/crate-entity-pages-common';

export const trackIsEditingToggle = (isEditing: boolean): void => {
  trackAction(
    {
      [TRACKING.ENTITY_PAGE_CHANGE_ACTOR_TYPE]: 1,
      [TRACKING.PROP_ACTOR_TYPE]: isEditing ? 'entity_page' : 'user',
    },
    'EventChangeActorType'
  );
};

export const trackOpenNavInfoBox = (): void =>
  trackAction({
    [TRACKING.PROP_TRACK_ACTION]: 'entity_page_info',
  });
